import { Action } from '@/_core/fluxstore/types';
import { SlidePanelState } from '../types';

import { useAppSlidePanelModule } from '..';
const { registerReducer } = useAppSlidePanelModule();

export class CloseSlidePanel extends Action<SlidePanelState> {
    public static ACTION_TYPE = 'SlidePanelState::CloseSlidePanel';

    public constructor() {
        super(CloseSlidePanel.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer2 = (state: SlidePanelState, action: CloseSlidePanel): void => {
    state.isOpen = false;
};

//@ts-ignore
registerReducer(CloseSlidePanel.ACTION_TYPE, reducer2);
